import React, { useEffect, useState, useRef, useContext } from "react";
import "./CircleBtn.css";
import { Container, Row, Col, Button, Form } from "react-bootstrap";
import { Await, Link, useLocation } from "react-router-dom";
import { MainContext } from "../../contexts/MainContext";
import apiUrl from "../../utils/ApiConfig";
import { filterShapesByInput } from "../../utils/filterShapesByInput";
import NatijehLink from "../../utils/NatijehLink";
export default function CircleBtn() {
  const location = useLocation();

  let { zayechB, setZayechB, zayechC, setZayechC, XallShaps, setXAllShaps, setFlag, vlue16, imageElement, imageRef, setSecondSelectDisabled, secondSelectDisabled, setBatnName } =
    useContext(MainContext);

  const [adminCircle, setAdminCircle] = useState([]);
  const [hsgdha, setsakd] = useState(false);

  const [firstSelectValue, setFirstSelectValue] = useState("");
  const [secondSelectValue, setSecondSelectValue] = useState("");

  useEffect(() => {
    imageElement.current = imageRef.current;
  }, [imageRef.current]);
  const getAdminCircle = async () => {
    const res = await fetch(`${apiUrl}/api/AgDayerehs`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }).then((res) => {
      if (res.ok) {
        return res.json().then((result) => {
          setAdminCircle(result);
        });
      }
    });
  };

  const fetchData = async (value, id, fun) => {
    ///////by passing: code by lenth 16  that gived from user ,get by this api another code by lenth 16 and by filter on this code, recive zayecheB
    const obj = {
      value: value,
      id: id,
    };
    async function myApp() {
      const res = await fetch(`${apiUrl}/CalDayere`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(obj),
      }).then((res) => {
        if (res.ok) {
          return res.json().then((result) => {
            const resultB = filterShapesByInput(XallShaps, result.value);
            fun(resultB);
          });
        }
      });
    }
    myApp();
  };

  const getTaleShahed = async (url, value, fun) => {
    const obj = {
      value: value,
      id: 0,
    };
    async function myApp() {
      const res = await fetch(`${apiUrl}${url}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(obj),
      }).then((res) => {
        if (res.ok) {
          return res.json().then((result) => {
            console.log(value);
            console.log(result.value);
            const resultB = filterShapesByInput(XallShaps, result.value);
            fun(resultB);
          });
        }
      });
    }
    myApp();
  };

  const checkElementsExist = () => {
    if (!imageElement.current) {
      imageElement.current = imageRef.current;
    }
  };
  const updateImage1 = (value1, value2) => {
    if (!location.pathname.includes("ramlpic")) {
      checkElementsExist();
      if (value1 !== "" && value2 === "") {
        imageElement.current.src = "./images/pagePishrafte/dayere5.png";
        setZayechC([]);
        localStorage.setItem("imgsrc", "./images/pagePishrafte/dayere5.png");
      } else if (value1 !== "" && value2 !== "") {
        imageElement.current.src = "./images/pagePishrafte/dayere6.png";
        localStorage.setItem("imgsrc", "./images/pagePishrafte/dayere6.png");
      } else if (value1 === "" && value2 === "") {
        imageElement.current.src = "./images/pagePishrafte/dayere4.png";
        setZayechB([]);
        setZayechC([]);

        localStorage.setItem("imgsrc", "./images/pagePishrafte/dayere4.png");
      } else if (value1 === "" && value2 !== "") {
        imageElement.current.src = "./images/pagePishrafte/dayere4.png";
        setZayechB([]);
        setZayechC([]);
        setSecondSelectDisabled(true);
        localStorage.setItem("imgsrc", "./images/pagePishrafte/dayere4.png");
      }
    }
  };
  useEffect(() => {
    getAdminCircle(); ///get batn,sokon & ...
  }, []);

  const handleZayechBChange = (e) => {
    setFlag(true);
    const selectedOption = e.target.value;
    setFirstSelectValue(selectedOption);
    setSecondSelectDisabled(selectedOption === "");
    if (selectedOption === "") {
      setZayechB([]);
      setSecondSelectValue(""); // Set second select value to null when first select is null
    }
    if (!location.pathname.includes("ramlpic")) {
      updateImage1(selectedOption, secondSelectValue);
    }
    if (selectedOption === "shahed") {
      getTaleShahed("/GetShahed", vlue16, setZayechB);
    } else if (selectedOption === "tale") {
      getTaleShahed("/GetTale", vlue16, setZayechB);
    } else {
      fetchData(vlue16, selectedOption, setZayechB);
    }

    setBatnName(() => {
      ///=>نام گذاری برای استفاده در مربع اشکال در ramlPic
      if (selectedOption === "tale") {
        return "دایره طالع";
      } else if (selectedOption === "shahed") {
        return "دایره شاهد";
      } else {
        const batn = adminCircle.filter((filter) => filter.id == selectedOption)[0]?.name;
        return batn;
      }
    });
  };

  const handleZayechCChange = (e) => {
    setFlag(true);
    const selectedOption = e.target.value;
    setSecondSelectValue(selectedOption);
    updateImage1(firstSelectValue, selectedOption);
    setZayechC([]);
    if (selectedOption === "shahed") {
      getTaleShahed("/GetShahed", vlue16, setZayechC);
    } else if (selectedOption === "tale") {
      getTaleShahed("/GetTale", vlue16, setZayechC);
    } else {
      fetchData(vlue16, selectedOption, setZayechC);
    }
  };

  // useEffect(() => {
  //   // alert('sss')
  //   setFlag(true);
  //   const updateImage2 = (value1, value2) => {
  //     if (imageRef.current !== undefined && imageRef.current !== null) {
  //       if (value1 !== "" && value2 === "") {
  //         imageElement.current.src = "./images/pagePishrafte/dayere5.png";
  //         setZayechC([]);
  //         setFlag(true);
  //       } else if (value1 !== "" && value2 !== "") {
  //         imageElement.current.src = "./images/pagePishrafte/dayere6.png";
  //         setFlag(true);
  //       } else if (value1 === "" && value2 === "") {
  //         imageElement.current.src = "./images/pagePishrafte/dayere4.png";
  //         setZayechB([]);
  //         setZayechC([]);
  //         setFlag(true);
  //       } else if (value1 === "" && value2 !== "") {
  //         imageElement.current.src = "./images/pagePishrafte/dayere4.png";
  //         setZayechB([]);
  //         setZayechC([]);

  //         setSecondSelectDisabled(true);
  //         setFlag(true);
  //       }
  //     }
  //   };

  //   updateImage2(firstSelectValue, secondSelectValue);
  // }, [hsgdha]);

  // ///////////////////
  // useEffect(() => {
  //   setTimeout(() => {
  //     setsakd((prev) => !prev);
  //   }, 400);
  // }, []);

  return (
    <Container>
      <Row>
        {adminCircle && (
          <Col center>
            <div center className="d-grid gap-2">
              <br />
              <br />
              <Form.Select id="firstSelect" value={firstSelectValue} onChange={handleZayechBChange} aria-label="Default select example">
                <option value="">بطن را انتخاب کنید</option>
                {adminCircle.map((item) => (
                  <option key={item.id} value={item.id}>
                    بطن در {item.name}
                  </option>
                ))}
                <option value="shahed"> شاهد</option>
                <option value="tale"> طالع</option>
              </Form.Select>

              {!location.pathname.includes("ramlpic") && (
                <Form.Select id="secondSelect" value={secondSelectValue} onChange={handleZayechCChange} disabled={secondSelectDisabled} aria-label="Default select example">
                  <option value="">بطن را انتخاب کنید</option>

                  {adminCircle.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                  <option value="shahed"> شاهد</option>
                  <option value="tale"> طالع</option>
                </Form.Select>
              )}

              {!location.pathname.includes("ramlpic") && (
                <div center className="d-grid gap-2">
                  <br />
                  <br />

                  <Link
                    className="linkBtn"
                    to="/ramlpic"
                    onClick={() => {
                      setZayechB([]);
                    }}
                  >
                    {" "}
                    زایچه درختواره{" "}
                  </Link>
                  <Link className="linkBtn" to="/RamlNazar">
                    {" "}
                    نظرات نجومی{" "}
                  </Link>
                  <Link className="linkBtn" to="/RamlJadval">
                    قـوت و ضـعـف
                  </Link>
                  <NatijehLink style={true} />
                  <br />
                  <br />
                </div>
              )}
            </div>
          </Col>
        )}
      </Row>
    </Container>
  );
}
